const LEGACY_SECTION_BACKGROUND_MAP: Record<string, string> = {
  White: "background.default",
  Blue: "background.brand_subtle",
  Gray: "background.warm_strong",
  Warm: "background.warm",
  "Light Blue": "background.cool_strong",
  Transparent: "transparent"
};

const DARK_BACKGROUNDS = new Set(["background.brand", "background.brand_subtle", "primary.main"]);

export const WHITE_SWIRL_BACKGROUND = "White + Swirl";

export const resolveLandingPageSectionBackgroundColor = (
  backgroundColor?: string,
  fallback = "transparent"
) => {
  if (!backgroundColor) {
    return fallback;
  }

  if (backgroundColor === WHITE_SWIRL_BACKGROUND) {
    return "background.default";
  }

  return LEGACY_SECTION_BACKGROUND_MAP[backgroundColor] ?? backgroundColor;
};

export const shouldUseLandingPagePatternBackground = (
  backgroundColor?: string,
  useDefaultSwirl = false
) => {
  if (!backgroundColor) {
    return useDefaultSwirl;
  }

  return backgroundColor === WHITE_SWIRL_BACKGROUND;
};

export const isDarkLandingPageBackground = (backgroundColor?: string) =>
  DARK_BACKGROUNDS.has(resolveLandingPageSectionBackgroundColor(backgroundColor));

// Anchor text colors are selected for contrast against each landing-page background:
// Blue -> primary.contrastText, Light Blue -> primary.main,
// and White, Gray, or Transparent -> secondary.main.
export const resolveLandingPageAnchorTextColor = (backgroundColor?: string) => {
  const resolvedBackgroundColor = resolveLandingPageSectionBackgroundColor(backgroundColor);

  if (DARK_BACKGROUNDS.has(resolvedBackgroundColor)) {
    return "primary.contrastText";
  }

  return resolvedBackgroundColor === "background.cool_strong" ? "primary.main" : "secondary.main";
};